var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdsMobileAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#001B53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2794 39.8077C28.8941 37.7113 31.0324 35.0747 32.55 32.0757C34.5081 28.5542 35.0297 24.4038 34.0045 20.502C32.5574 15.625 27.6342 12.6851 22.6917 13.7466C22.4492 13.7466 22.1907 13.7466 21.8674 13.8443C22.3831 11.5337 23.5636 9.4274 25.2613 7.78886C25.5685 7.56248 25.9503 7.46343 26.3279 7.51213C34.902 7.91286 41.6451 15.038 41.6321 23.6833C41.6191 32.3286 34.8547 39.4331 26.2794 39.8077Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5735 33.7052C26.0789 35.9089 24.9971 37.9317 23.4465 39.5523C23.2009 39.7502 22.887 39.8389 22.5761 39.7979C14.3761 39.1978 7.96359 32.3714 7.75521 24.0204C7.54683 15.6695 13.6106 8.52164 21.7702 7.5C21.3994 7.82757 21.1415 8.05686 20.8997 8.30253C16.1456 12.6943 13.9167 19.2419 14.9842 25.6799C15.3683 28.2157 16.734 30.4904 18.7774 31.9977C20.8208 33.5049 23.3724 34.1197 25.8643 33.7052C26.1004 33.6885 26.3374 33.6885 26.5735 33.7052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9563 24.1832C20.9563 22.7427 20.9563 21.318 20.9563 19.8933C20.9563 18.4687 21.5032 18.3104 22.5527 18.8961C24.9176 20.3049 27.2826 21.7296 29.618 23.1701C30.5787 23.7558 30.5787 24.4364 29.618 25.0221C27.2234 26.5101 24.8289 27.9665 22.4049 29.4069C21.5328 29.9293 20.9268 29.6127 20.9268 28.5521C20.9268 27.0958 20.9268 25.6395 20.9268 24.1832",
    fill: "#1C6ACF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdsMobileAppLogo);
export default __webpack_public_path__ + "static/media/cds-mobile-app-logo.a8063e85e15c09a83aed4b09f9b2164b.svg";
export { ForwardRef as ReactComponent };